<alaris-dialog
	[closeAction]="close"
	[confirmAction]="confirm"
	[loading$]="service.loading$"
	confirmButtonText="gl.create"
	size="md"
	[disabled]="form.invalid">
	<h6 slot="header">{{ 'simulation.add_title' | translate }}</h6>
	<div slot="content">
		<form [formGroup]="form">
			<div [alarisFade]="'vertical'" class="form-group">
				<alaris-input formControlName="SenderId" [errors]="errors">
					{{ 'simulation.sender_id' | translate }}
				</alaris-input>
				<alaris-input formControlName="Prefix" [errors]="errors">
					{{ 'simulation.prefix' | translate }}
				</alaris-input>
				<alaris-select2 [label]="'simulation.product_type' | translate" formControlName="ProductsType" [errors]="errors">
					@for (type of productNamesTypes; track type) {
						<alaris-options2 [value]="type">
							{{ type }}
						</alaris-options2>
					}
				</alaris-select2>

				<alaris-select2 [alarisLoading]="productsService.loading$" [backdrop]="false"
								[expandable]="true"
								[label]="'simulation.product_name' | translate" formControlName="ProductName">
					<alaris-select-filter2 [formControl]="productsNamesFilter"></alaris-select-filter2>
					@for (name of productsNames; track name) {
						<alaris-options2 [value]="name">{{ name }}</alaris-options2>
					}
				</alaris-select2>

				<alaris-select2 [alarisLoading]="productsService.loading$" [backdrop]="false"
								[displayWith]="displayProduct" [expandable]="true"
								[label]="'simulation.client_product' | translate" formControlName="ProductId">
					<alaris-select-filter2 [formControl]="productsFilter"></alaris-select-filter2>
					@for (product of products; track product.product_id) {
							@if (product.product_id) {
							<alaris-options2 [value]="product.product_id">
								<span>{{ product.product_caption }}
									({{ product.acc_currency_code }}) ({{ product.product_id }})</span>
							</alaris-options2>
							}
					}
				</alaris-select2>
			</div>
		</form>
	</div>
</alaris-dialog>
